export default {
  tags: {
    handle: 'TagsConf',
    closeall: 'Close All',
    closeother: 'Close Other'
  },
  route: {
    dataScreen: 'DataScreen',
    deviceManagement: 'DeviceManage',
    deviceOverview: 'DeviceOverview',
    inventoryRecord: 'InventoryRecord',
    agentManagement: 'AgentManage',
    agentType: 'AgentType',
    agentTypeSet: 'AgentTypeSet',
    userManagement: 'UserManagement',
    productSet: 'ProductSet',
    revenueCenter: 'RevenueCenter',
    orderCenter: 'OrderCenter',
    messageCenter: 'MessageCenter',
    profile: 'Profile',
    commodityCenter: 'CommodityCenter'
  },
  app: {
    switchlang: 'Switch Language Success',
    unlock: 'UNLOCK'
  },
  login: {
    edenPart1: 'Apple',
    edenPart2: 'WaterNetLease',
    btn: 'Login',
    register: 'register',
    radioEN: 'English',
    radioZH: 'Chinese',
    forgetpwd: 'Forget Password',
    remember: 'Remember',
    userplaceholder: 'please enter lovely username',
    pwdplaceholder: 'please enter lovely password',
    forget_email: 'please enter email',
    forget_code: 'please enter code',
    forget_passwrd: 'please enter new password',
    confirm_passwrd: 'confirm new password',
    forget_btn: 'Confirm',
    forget_back: 'Back',
    validfaild: 'Login form does not pass !',
    pwdChanged: 'Password Reset Successfully !'
  },
  sidebarDropDown: {
    profile: 'Profile',
    lock: 'Lock',
    logout: 'Logout'
  },
  msg: {
    msg1: 'Do you blow water together?',
    msg2: 'Do you eat chicken together?',
    msg3: 'Do you wear women clothes together?'
  },
  lock: {
    locked: 'Eden system has been locked!',
    unlock: 'Unlock Successfully!'
  }
}
